module.exports = __webpack_public_path__ + "img/Mongolia.59c3f732.png";